import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { AuthModule } from '@auth0/auth0-angular';
import { NgIdleModule } from '@ng-idle/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { cookieConsentInitializer } from './core/initializers/cookie-consent.initializer';
import { pendoAnalyticsInitializer } from './core/initializers/pendo-analytics.initializer';
import { sessionRecoveryInitializer } from './core/initializers/session-recovery.initializer';
import { inactivityInterceptor } from './core/interceptors/inactivity.interceptor';
import { authTokenInterceptor } from './core/interceptors/http.interceptor';
import { getAuth0CustomerConfig } from './core/utils/auth0-config.util';
import { detectMarket } from './core/utils/market.util';

const auth0MarketConfig = getAuth0CustomerConfig(detectMarket());

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideNativeDateAdapter(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
    ),
    provideHttpClient(withInterceptors([inactivityInterceptor, authTokenInterceptor])),
    provideAppInitializer(() => sessionRecoveryInitializer()),
    provideAppInitializer(() => {
      cookieConsentInitializer();
    }),
    provideAppInitializer(() => {
      pendoAnalyticsInitializer();
    }),
    importProvidersFrom(NgIdleModule.forRoot()),
    importProvidersFrom(
      AuthModule.forRoot({
        domain: environment.auth0.domain,
        clientId: auth0MarketConfig.clientId,
        authorizationParams: {
          redirect_uri: globalThis.location.origin,
          ...(environment.auth0.audience ? { audience: environment.auth0.audience } : {}),
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
      }),
    ),
  ],
};
